import { Data } from "@8x8/chalet-proto";
import moment from "moment";

const tenMinutes = 600;

export function formatDuration(seconds: number) {
    return moment
        .utc(moment.duration(seconds * 1000).asMilliseconds())
        .format(seconds < tenMinutes ? "m:ss" : "HH:mm:ss");
}

export function humanizeDuration(ms: number) {
    return moment.duration(ms).humanize();
}

export function formatLastSeen(lastSeen: Data.LastSeenInfo) {
    return moment.utc(lastSeen.ts + (lastSeen.tz ? lastSeen.tz * 60 : 0)).fromNow();
}

export function getCurrentTzOffset() {
    return -new Date().getTimezoneOffset();
}

export function formatUntil(unixTs: number) {
    // 1:23 PM on 12/25
    return moment.unix(unixTs).format("[until] LT [on] MM/DD");
}

export function getMuteForever() {
    return -1;
}

export function getMuteFor1Hour() {
    return moment()
        .add(1, "hour")
        .unix();
}

export function getMuteFor1Minute() {
    return moment()
        .add(1, "minute")
        .unix();
}

export function getMuteUntil8InMorning() {
    const currentHour = moment().hour();
    return moment()
        .add(currentHour >= 8 ? 1 : 0, "days")
        .startOf("day")
        .add(8, "hours")
        .unix();
}
